import { capitalised, plural } from "@healthos/shared";
export const CADENCE_LABEL = {
    once: "Once",
    weekly: "A few times a week",
    daily: "Every day",
};
/** "done 2 of 3 times", or "not come up yet". */
export const actionProgress = (a) => a.offered === 0 ? "not come up yet" : `done ${a.done} of ${plural(a.offered, "time", "times")}`;
/** "Every day at 18:00 · done 6 of 10 times" */
export const actionMeta = (a) => `${CADENCE_LABEL[a.cadence]}${a.localTime ? ` at ${a.localTime}` : ""} · ${actionProgress(a)}`;
/** "done, done 3 of 3 times" or "set aside, not come up yet", for a finished action. */
export const closedActionNote = (a) => `${a.status === "done" ? "done" : "set aside"}, ${actionProgress(a)}`;
/** The heading over a member's agreed actions: a care plan reads as a routine. */
export const actionsHeading = (care, coachFirst) => ({
    eyebrow: care ? `Your plan with ${coachFirst}` : `Agreed with ${coachFirst}`,
    title: care ? "Your routine" : "Things to try",
});
/** The agreed actions list, in the words of whoever is reading it. */
export function coachingActionsProps(actions, as, words) {
    const open = actions.filter((a) => a.status === "open");
    const closed = actions.filter((a) => a.status !== "open");
    return {
        open,
        closed,
        total: actions.length,
        finishedLabel: plural(closed.length, "finished action", "finished actions"),
        empty: as === "coach"
            ? `Nothing agreed yet. Add what you agree in ${words.aSession} and Heartbeat brings it back on the days it matters.`
            : `When you and ${words.yourTeam} agree something to try, it shows here and Heartbeat reminds you.`,
        acted: `Nice. ${capitalised(words.yourTeam)} will see it.`,
    };
}
//# sourceMappingURL=coaching-actions.js.map